import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../shared/context/AuthContext';
import { getHomePath } from '../../shared/utils/homePath';
import VerifyTokenForm from './components/VerifyTokenForm';
import './styles.css';

export default function VerifyTokenPage() {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate(getHomePath(user?.role), { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate, user?.role]);

  // Si no hay token en la URL, redirigir
  useEffect(() => {
    if (!token) {
      navigate('/login', { replace: true });
    }
  }, [token, navigate]);

  // Mostrar loading mientras se verifica la autenticación
  if (isLoading) {
    return null;
  }

  if (!token) {
    return null;
  }

  return (
    <div className="verify-token-page">
      <div className="verify-token-card">
        <VerifyTokenForm token={token} />
      </div>
    </div>
  );
}
